/*
 * Quick-add: click the bag icon on a product card to add the product's
 * first available variant to the cart, then open the cart drawer.
 */
(function () {
  if (window.__ahuQuickAddBound) return;
  window.__ahuQuickAddBound = true;

  function showToast(message) {
    var toast = document.querySelector('.ahu-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ahu-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML =
        '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M3 10l4 4 10-10" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '<span data-ahu-toast-msg></span>';
      document.body.appendChild(toast);
    }
    toast.querySelector('[data-ahu-toast-msg]').textContent = message;
    toast.classList.add('is-shown');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () { toast.classList.remove('is-shown'); }, 2500);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-ahu-quick-add]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    if (btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalLabel = btn.getAttribute('aria-label');
    btn.setAttribute('disabled', '');
    btn.style.opacity = '0.6';

    var body = {
      items: [{ id: variantId, quantity: 1 }]
    };

    // Tell Dawn's cart-drawer which sections to re-render on success.
    // getSectionsToRender() returns entries keyed by `id` (plus an optional `selector`),
    // NOT `section`. Reading `.section` produced [undefined, undefined], so Shopify
    // returned no sections, renderContents was skipped, and the drawer opened still
    // showing the empty state it was server-rendered with.
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && typeof drawerEl.getSectionsToRender === 'function') {
      body.sections = drawerEl
        .getSectionsToRender()
        .map(function (s) { return s.id; })
        .filter(Boolean);
      body.sections_url = window.location.pathname;
    }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function (data) {
        // Refresh the cart-icon-bubble count via the cart object
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var bubbleSpan = document.querySelector('#cart-icon-bubble [data-ahu-cart-count]');
          if (bubbleSpan) bubbleSpan.textContent = cart.item_count;

          // Open Dawn's cart drawer if available; otherwise show a toast
          if (drawerEl && typeof drawerEl.open === 'function') {
            if (data.sections) {
              try { drawerEl.renderContents(data); } catch (e) {}
            }
            // The `is-empty` class lives on the <cart-drawer> host, and
            // `cart-drawer.is-empty .drawer__inner` hides the contents. renderContents
            // only clears it from .drawer__inner, so on the first add to an empty cart
            // the drawer would open with the freshly rendered items still hidden.
            if (cart.item_count > 0) {
              drawerEl.classList.remove('is-empty');
              var inner = drawerEl.querySelector('.drawer__inner');
              if (inner) inner.classList.remove('is-empty');
              var items = drawerEl.querySelector('cart-drawer-items');
              if (items) items.classList.remove('is-empty');
            }
            drawerEl.open(btn);
          } else {
            showToast('Added to cart');
          }
        });
      })
      .catch(function () {
        // Fallback: navigate to product URL so user can pick a variant manually
        var productUrl = btn.getAttribute('data-product-url');
        if (productUrl) window.location.href = productUrl;
      })
      .finally(function () {
        btn.removeAttribute('disabled');
        btn.style.opacity = '';
        if (originalLabel) btn.setAttribute('aria-label', originalLabel);
      });
  });
})();
